import KunLoading71 from './src/index'

KunLoading71.install = function (Vue) {
	Vue.component(KunLoading71.name, KunLoading71);
}

export default KunLoading71;
